import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b7c41550&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b7c41550&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=b7c41550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c41550",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetNuxt: require('/data/wwwroot/xd-website/sys-builder/v3.0/bale/nuxt-www.taptap.cn/apps/baler-nuxt-pre/components/widget-nuxt.vue').default,LazyAutoAdaptive: require('/data/wwwroot/xd-website/sys-builder/v3.0/bale/nuxt-www.taptap.cn/apps/baler-nuxt-pre/components/lazy-auto-adaptive.vue').default,TrackBehavior: require('/data/wwwroot/xd-website/sys-builder/v3.0/bale/nuxt-www.taptap.cn/apps/baler-nuxt-pre/components/track-behavior.vue').default,GlobalCodeBox: require('/data/wwwroot/xd-website/sys-builder/v3.0/bale/nuxt-www.taptap.cn/apps/baler-nuxt-pre/components/global-code-box.vue').default,GlobalUiBox: require('/data/wwwroot/xd-website/sys-builder/v3.0/bale/nuxt-www.taptap.cn/apps/baler-nuxt-pre/components/global-ui-box.vue').default,LazyCountdown: require('/data/wwwroot/xd-website/sys-builder/v3.0/bale/nuxt-www.taptap.cn/apps/baler-nuxt-pre/components/lazy-countdown.vue').default})
